import React from 'react'

export default ({ children }) =>(
	<main className="content">
		{ children }
	</main>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Main.js